import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { stylesConstants } from '../../../styles/stylesConstants';

export default makeStyles((theme: Theme) => ({
  column: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minWidth: stylesConstants.inputFormWidth,
    marginRight: theme.spacing(2),
    marginLeft: theme.spacing(2),
  },
  row: {
    marginY: 2,
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
}));
